/**
 * ISSUE-1042 R6: each refusal POST /contest/create can return shows its own
 * sentence inline in the New contest form, and the dialog stays open. The
 * handler refs are #20260819-contest311 (FORBIDDEN_ROLE),
 * #20260819-contest312 (VALIDATION_ERROR name), #20260819-contest313
 * (VALIDATION_ERROR config), #20260819-contest314 (NOT_FOUND season),
 * #20260819-contest315 (CONTEST_IN_PROGRESS) and #20260819-contest316
 * (CONTEST_DATES_OVERLAP). Anything else goes to the shared error modal.
 */
import { NEW_CONTEST_NO_SEASON_BODY } from "./newContestModel";

export const NEW_CONTEST_NAME_REFUSED_NOTE =
  "Enter a contest name of 1 to 60 characters.";
export const NEW_CONTEST_CONFIG_REFUSED_NOTE =
  "Some of these rules don't work together. Check the dates and numbers, then try again.";
export const NEW_CONTEST_JOINED_AFTER_START_NOTE =
  "You joined this pool after that start date. Pick a start date on or after the day you joined.";
export const NEW_CONTEST_OVERLAP_NOTE =
  "These dates overlap another contest in this pool. Pick dates that don't overlap.";
export const NEW_CONTEST_FORBIDDEN_NOTE =
  "Only the Commissioner and Admins can start a contest.";

export type typeCreateFailureTreatment =
  { kind: "inline"; note: string } | { kind: "modal" };

export function createFailureTreatment(input: {
  code: string | null;
  reason: string | null;
}): typeCreateFailureTreatment {
  const { code, reason } = input;
  if (code === "VALIDATION_ERROR" && reason === "name") {
    return { kind: "inline", note: NEW_CONTEST_NAME_REFUSED_NOTE };
  }
  if (code === "VALIDATION_ERROR" && reason === "config") {
    return { kind: "inline", note: NEW_CONTEST_CONFIG_REFUSED_NOTE };
  }
  if (code === "NOT_FOUND" && reason === "season") {
    return { kind: "inline", note: NEW_CONTEST_NO_SEASON_BODY };
  }
  if (code === "CONTEST_IN_PROGRESS") {
    return { kind: "inline", note: NEW_CONTEST_JOINED_AFTER_START_NOTE };
  }
  if (code === "CONTEST_DATES_OVERLAP") {
    return { kind: "inline", note: NEW_CONTEST_OVERLAP_NOTE };
  }
  if (code === "FORBIDDEN_ROLE") {
    return { kind: "inline", note: NEW_CONTEST_FORBIDDEN_NOTE };
  }
  return { kind: "modal" };
}
